<template>
  <div class="footer">
    <div class="batch">
      <div class="myMai">©Copyright PT Solusi kecerdasan artifisial</div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.footer {
  background-color: #fff;
  text-align: center;
}
.batch {
  width: 100%;
  background: #f7f9f8;
  padding: 0.346667rem /* 13/37.5 */ 0;
  .myMai {
    text-align: center;
    color: rgba(36, 43, 42, 0.7);
    font-size: 0.32rem /* 12/37.5 */;
    font-weight: 400;
  }
}
</style>
